export const shortTenantId = (id) => {
  if (!id || id.length < 12) {
    return id || '';
  }
  return `${id.slice(0, 8)}…${id.slice(-4)}`;
};

export const initialsFor = (firstName, lastName) => (
  `${(firstName || ' ').charAt(0)}${(lastName || ' ').charAt(0)}`.trim().toUpperCase()
);

export const countWord = (count, singular, plural = `${singular}s`) => (
  `${count} ${count === 1 ? singular : plural}`
);

export const canReachStep = (target, {
  userCount,
  tenantCount,
  invalidCount,
  appCount,
}) => {
  if (target <= 1) {
    return true;
  }
  if (userCount < 1) {
    return false;
  }
  if (target === 2) {
    return true;
  }
  if (tenantCount < 1 || invalidCount > 0) {
    return false;
  }
  if (target === 3) {
    return true;
  }
  return appCount > 0;
};
